import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {   Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Dropdown,
    Button,
    Modal,
    DropdownMenu,
    DropdownItem, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { APPNAME } from 'helpers/url_helper';
import avatar1 from "../../assets/images/users/avatar-1.jpg"

//import images
import vacancy from "../../assets/images/companies/Screenshot_2.png";
import logo from "../../assets/images/logo-dark.png";

import axios from 'axios';
import * as url from "../../helpers/url_helper"
import { HRConfig } from 'helpers/backend_helper';
import { useHistory, useParams } from 'react-router-dom';

    const VacancyDetails = () => {
        const {id} = useParams()
        const [recrProjNo, setRecrProjNo] = useState("")
        const [positionCode, setPositionCode] = useState("")
        const [jobTitle, setJobTitle] = useState("")
        const [quantityRequested, setQuantityRequested] = useState("")
        const [applicationSubmissionDeadline, setApplicationSubmissionDeadline] = useState("")
        const history = useHistory();
        const [projects, setProjects] = useState([])
        const [username, setusername] = useState('')
        const [vacancies, setvacancies] = useState(0)
        const [applications, setapplications] = useState(0)
        const [isLoading, setIsLoading] = useState(false)

        const [positionDescription, setPositionDescription] = useState([])
        const [positionEducation, setPositionEducation] = useState([])
        const [positionCertificates, setPositionCertificates] = useState([])
        const [positionSkills, setPositionSkills] = useState([])
        const [vacanciesAvailable, setVacanciesAvailable] = useState('')

        const fetchProjects = () =>{
            setIsLoading(true)
            axios.get(`${url.RECRUITMENTPROJECTSX}(${id})?$expand=positionDescription,positionEducation,positionCertificates,positionSkills`, HRConfig).then((r)=>{
                
                setRecrProjNo(r.data.RecrProjNo)
                setPositionCode(r.data.PositionCode)
                setJobTitle(r.data.jobTitle)
                setQuantityRequested(r.data.QuantityRequested)
                setApplicationSubmissionDeadline(r.data.applicationSubmissionDeadline)
                setPositionDescription(r.data.positionDescription)
                setPositionEducation(r.data.positionEducation)
                setPositionCertificates(r.data.positionCertificates)
                setPositionSkills(r.data.positionSkills)
                setIsLoading(false)
                
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        }
        useEffect(() => {
            if (localStorage.getItem("authApplicant")) {
                const obj = JSON.parse(localStorage.getItem("authApplicant"))
                setusername(`${obj.fname} ${obj.lname}`)
                fetchProjects()
                console.log(id)            }
          }, [])

          //MMO New Details page
          return (
            <div className="page-content">
            <MetaTags>
            <title>Vacancy details | {APPNAME}</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title={APPNAME} breadcrumbItem="Vacancy details" />
                <Row>
                    <Col lg="12">
                    <Card>
                        <CardBody>
                        <Row>
                            <Col lg="5">
                            <div className="d-flex">
                                <div className="me-3">
                                <img
                                    src={avatar1}
                                    alt=""
                                    className="avatar-md rounded-circle img-thumbnail"
                                />
                                </div>
                                <div className="flex-grow-1 align-self-center">
                                <div className="text-muted">
                                    <p className="mb-2">Welcome to MILDMAY Job applications portal</p>
                                    <h5 className="mb-1">{username}</h5>
                                    <p className="mb-0">Applicant</p>
                                </div>
                                </div>
                            </div>
                            </Col>

                            <Col lg="7" className="align-self-center">
                            <div className="text-lg-center mt-4 mt-lg-0">
                                <Row>
                                <Col xs="6">
                                    <div>
                                    <p className="text-muted text-truncate mb-2">
                                        Vacancies
                                    </p>
                                    <h5 className="mb-0">3</h5>
                                    </div>
                                </Col>
                                <Col xs="6">
                                    <div>
                                    <p className="text-muted text-truncate mb-2">
                                        Applications
                                    </p>
                                    <h5 className="mb-0">0</h5>
                                    </div>
                                </Col>
                                
                                </Row>
                            </div>
                            </Col>

                            
                        </Row>
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                
            <React.Fragment>
            <Row>
                <Col xl={3}>
                    <Card>
                        <CardBody className="border-bottom">
                        <h5 className="fw-semibold">Overview</h5>
                            <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th scope="col">Project No</th>
                                        <td scope="col"> {recrProjNo} </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Position Code</th>
                                        <td scope="col">{positionCode}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Position Title</th>
                                        <td scope="col">{jobTitle}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Vacancy</th>
                                        <td>{quantityRequested}</td>
                                    </tr>
{                                   /* <tr>
                                        <th scope="row">Job Type</th>
                                        <td><span className="badge badge-soft-success">Full Time</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Posted Date</th>
                                        <td>25 June, 2022</td>
                                    </tr> */}
                                    <tr>
                                        <th scope="row">Close Date</th>
                                        <td>{applicationSubmissionDeadline}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="hstack gap-2">
                            <button className="btn btn-success btn-block w-100" onClick={() => {history.push(`/create-application/${id}`)}}><i className="mdi mdi-open-in-new"/>{"  "}Apply Now</button>                            
                            <Dropdown tag="a" href="https://www.MILDMAY.com/contact-us/" target="_blank" className="btn btn-primary btn-block w-100" ><i className="mdi mdi-phone-classic"/>{"  "}Contact Us</Dropdown>
                        </div>
                        </CardBody>
                    </Card>
                    <Card>
                    <CardBody>
                        <div className="text-center">
                            <img src={logo} alt="" height="50" className="mx-auto d-block" />
                            <h5 className="mt-3 mb-1">Uganda Electricity Generation Company Ltd.</h5>
                            <p className="text-muted mb-0">Since 2001</p>
                        </div>

                        <ul className="list-unstyled mt-4">
                            <li>
                                <div className="d-flex">
                                    <i className="bx bx-phone text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Phone</h6>
                                        <p className="text-muted fs-14 mb-0">+256 312 372165</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-mail-send text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Email</h6>
                                        <p className="text-muted fs-14 mb-0">info@MILDMAY.go.ug</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-globe text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Website</h6>
                                        <p className="text-muted fs-14 text-break mb-0">www.MILDMAY.com</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-map text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Location</h6>
                                        <p className="text-muted fs-14 mb-0">Block C Plot 6-9 Okot Close Bukoto Victoria Office</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="hstack gap-2">
                            <Dropdown tag="a" href="https://www.google.com/maps/place/Uganda+Electricity+Generation+Company+Limited/@0.344662,32.593772,15z/data=!4m6!3m5!1s0x177dbbb20980436b:0xfc1d7682397704fa!8m2!3d0.3446615!4d32.5937724!16s%2Fg%2F11dymg3mfm?hl=en&entry=ttu" target="_blank" className="btn btn-primary btn-block w-100" ><i className="mdi mdi-google-maps"/>{" "}View Map</Dropdown>
                        </div>
                    </CardBody>
                </Card>
                </Col>


                <Col xl={9}>
                    <Card>
                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">{jobTitle}</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                        <li>
                                            <i className="bx bx-building-house"></i> <span className="text-muted">MILDMAY</span>
                                        </li>
                                        <li>
                                            <i className="bx bx-map"></i> <span className="text-muted">Uganda</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </CardBody>

                        <CardBody>
                            <h5 className="fw-semibold mb-1">JOB SUMMARY</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '1. Job Summary') && <> 
                                            <Col className="text-muted">  
                                                <Col sm={12}>        
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>     
                                            </Col>                                        
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>

                        <CardBody>
                            <h5 className="fw-semibold mb-1">KEY RESPONSIBILITIES</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '2. Key Responsiblities') && <> 
                                            <Col className="text-muted">  
                                                <Col sm={12}>        
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>     
                                            </Col>                                      
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>
                        <CardBody>
                            <h5 className="fw-semibold mb-1">REPORTING RELATIONSHIPS</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '3. Reporting Relationships') && <> 
                                            <Col className="text-muted">
                                                <Col sm={12}>        
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>     
                                            </Col>                                       
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>
                        <CardBody>
                            <h5 className="fw-semibold mb-1">CONTACTS</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '4. Contacts') && <> 
                                            <Col className="text-muted">  
                                                <Col sm={12}>        
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>     
                                            </Col>                                        
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>
                        <CardBody>
                            <h5 className="fw-semibold mb-1">JOB EXPERIENCE</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '6. Related Job Experience') && <> 
                                            <Col className="text-muted">  
                                                <Col sm={12}>        
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>     
                                            </Col>                                        
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>
                        <CardBody>
                            <h5 className="fw-semibold mb-1">ADDITIONAL SKILLS</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '7. Additional Skills') && <> 
                                            <Col className="text-muted">  
                                                <Col sm={12}>        
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>     
                                            </Col>                                        
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>
                        <CardBody>
                            <h5 className="fw-semibold mb-1">ADDITIONAL INFORMATION</h5>
                                {(positionDescription.map((i,k)=>(
                                    <Row key={k}>
                                        {(i.type == '8. Additional Information') && <> 
                                            <Col className="text-muted">  
                                                <Col sm={12}>
                                                    <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}    
                                                </Col>
                                            </Col>                                        
                                        </> }
                                    </Row>
                                )))}
                        </CardBody>
                    </Card>
                    <Row>
                    <Col xl={6}>
                    <Card>
                        <CardBody>
                        <h5 className="fw-semibold mb-1">EDUCATION AND ACADEMIC QUALIFICATIONS</h5>
                            {(positionEducation.map((i,k)=>(
                                <Row key={k}>
                                    <Col className="mb-1">
                                            <Row  className="m-1 mb-1">          
                                                    <Col sm={12}>
                                                        <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}
                                                    </Col>     
                                                                                        
                                            </Row>
                                    </Col>
                                </Row>
                            )))}
                        </CardBody>
                    </Card>
                    </Col>
                    <Col xl={6}>
                    <Card>
                        <CardBody>
                        <h5 className="fw-semibold mb-1">CERTIFICATES</h5>
                            {(positionCertificates.map((i,k)=>(
                                <Row key={k}>
                                    <Col className="mb-1">
                                            <Row  className="m-1 mb-1">        
                                                    <Col sm={12}>
                                                        <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}
                                                    </Col>                              
                                            </Row>
                                    </Col>
                                </Row>
                            )))}
                        </CardBody>
                    </Card>
                    </Col>
                    {/* <Col xl={3}>
                    <Card>
                        <CardBody>
                        <h5 className="fw-semibold mb-1">SKILLS</h5>
                            {(positionSkills.map((i,k)=>(
                                <Row key={k}>
                                    <Col className="mb-1">
                                            <Row  className="m-1 mb-1">              
                                                    <Col sm={12}>
                                                        <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}
                                                    </Col>                                              
                                            </Row>
                                    </Col>
                                </Row>
                            )))}
                        </CardBody>
                    </Card>
                    </Col> */}
                    </Row>
                </Col>
                </Row>
            </React.Fragment>
            
            </Container>
            </div>
        );
    }

export default VacancyDetails;